import type { Components, Theme } from "@mui/material/styles";
import { darkColors, lightColors } from "../tokens/colors.ts";
import { elevation } from "../tokens/elevation.ts";

export function getMuiTextField(mode: "dark" | "light"): Components<Theme>["MuiTextField"] {
  const c = mode === "dark" ? darkColors : lightColors;
  return {
    styleOverrides: {
      root: {
        "& .MuiOutlinedInput-root": {
          backgroundColor: c.surfaceContainerHighest,
          border: elevation.ghostBorder[mode],
          borderRadius: "0.375rem",
          "&.Mui-focused": {
            backgroundColor: mode === "dark" ? c.surfaceBright : c.surfaceContainerLowest,
            borderColor: c.primary,
            boxShadow: `0 0 0 4px ${c.surfaceTint}33`,
          },
          "& fieldset": {
            border: "none",
          },
        },
      },
    },
  };
}
